function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScanIconWhite = function SvgScanIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.142,
    height: 13.471,
    viewBox: "0 0 4.536 3.564"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 12h-2v3h-3v2h5zM7 9h3V7H5v5h2Zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16.01H3V4.99h18z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "matrix(.20616 0 0 .198 -.206 -.594)"
  }));
};
export default SvgScanIconWhite;